var baseURL = '';
export const environment = {
  production: true,
  name: 'production',
  appConfig: {
    apisBaseUrl: "https://gateway.miyarcapital.com.sa",
    notificationServiceBaseUrl: "https://notification.miyarcapital.com.sa",
    awsUrl: "https://mr-oss-prod-01.oss-me-central-1.aliyuncs.com/",
    moyassarPublishableKey: "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi"
  },
  mapKey: "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
};
